import { selectFactory } from '../helpers';

import { FIELDS, SELECTED_FIELDS } from './constants';

const selectCarReference = ({ carReference }) => {
  return carReference;
};

export const selectField = selectFactory({ selector: selectCarReference });

export const selectBrands = selectField(FIELDS.BRANDS);

export const selectBrandsFetch = selectField(FIELDS.BRANDS_FETCH);

export const selectError = selectField(FIELDS.ERROR);

export const selectModels = selectField(FIELDS.MODELS);

export const selectModelsFetch = selectField(FIELDS.MODELS_FETCH);

export const selectSelected = selectField(FIELDS.SELECTED);
export const selectSelectedFields = selectFactory({ selector: selectSelected });
export const selectSelectedBrand = selectSelectedFields(SELECTED_FIELDS.BRAND);
export const selectSelectedModel = selectSelectedFields(SELECTED_FIELDS.MODEL);
export const selectSelectedVersion = selectSelectedFields(SELECTED_FIELDS.VERSION);

export const selectVersions = selectField(FIELDS.VERSIONS);

export const selectVersionsFetch = selectField(FIELDS.VERSIONS_FETCH);
